import { render, staticRenderFns } from "./AllPackagesTable.vue?vue&type=template&id=5fd65128&scoped=true"
import script from "./AllPackagesTable.vue?vue&type=script&lang=js"
export * from "./AllPackagesTable.vue?vue&type=script&lang=js"
import style0 from "./AllPackagesTable.vue?vue&type=style&index=0&id=5fd65128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd65128",
  null
  
)

export default component.exports